/**
 * Reference Role Vocabulary — bare value lists.
 * =============================================
 * Dependency-free on purpose. Model-config normalization derives reference
 * capability from these, and must not pull in the UI-rich role definitions
 * (labels, icons, CSS classes, vision-analysis prompts) that live in
 * `imageRoles.js` / `mediaReferenceRoles.js`.
 *
 * Those modules re-export these lists, so this is the single source of truth
 * for "which role ids exist", while they remain the source of truth for
 * "what a role looks like and means".
 */

/** Semantic image roles. Ordered — this is also the cycle order. */
export const IMAGE_REFERENCE_ROLE_VALUES = Object.freeze([
  'subject',
  'style',
  'scene',
  'structure',
]);

/** Video adds the two temporal roles, then shares the image vocabulary. */
export const VIDEO_REFERENCE_ROLE_VALUES = Object.freeze([
  'motion',
  'camera',
  ...IMAGE_REFERENCE_ROLE_VALUES,
]);

export const AUDIO_REFERENCE_ROLE_VALUES = Object.freeze(['audio-reference']);

/**
 * Positional image slots. Deliberately excluded from
 * IMAGE_REFERENCE_ROLE_VALUES: the outbound slot is chosen by array index, not
 * by the role string, so these are never user-selectable roles.
 */
export const NATIVE_IMAGE_REFERENCE_ROLE_VALUES = Object.freeze([
  'native-first',
  'native-last',
]);

/**
 * Roles a directive-tag transport can carry, keyed by media type.
 * Any media type absent here cannot express a semantic role.
 */
export const TRANSPORTABLE_ROLES_BY_MEDIA = Object.freeze({
  video: VIDEO_REFERENCE_ROLE_VALUES,
  image: IMAGE_REFERENCE_ROLE_VALUES,
  audio: AUDIO_REFERENCE_ROLE_VALUES,
});
